module.exports = __webpack_public_path__ + "media/images/duel/conflict-1-971bd4dff0cb9c02cc494e1998d14da7.jpg";